import { makeStyles } from "@material-ui/core/styles";
import PassIcon from "../../../assets/images/football/pass-line.svg";
import GameControlIcon from "../../../assets/images/football/game-control.svg";
import ChangePossessionIcon from "../../../assets/images/football/change-possesion.svg";
import PenaltyIcon from "../../../assets/images/football/penalty.svg";
import PuntIcon from "../../../assets/images/football/punt.svg";
import RushIcon from "../../../assets/images/football/rush.svg";
import ParticipantsIcon from "../../../assets/images/football/participants.svg";

const icons = {
	pass: PassIcon,
	rush: RushIcon,
	punt: PuntIcon,
	patTry: ChangePossessionIcon,
	participants: ParticipantsIcon,
	penalty: PenaltyIcon,
	changePossession: ChangePossessionIcon,
	gameControl: GameControlIcon
};

const cardButtonIconStyles = makeStyles((theme) => ({
	icon: {
		color: theme.palette.gameMode.primary,
		minHeight: "100%",
		minWidth: "100%",
		backgroundSize: "min(3vw, 44px)",
		backgroundRepeat: "no-repeat",
		backgroundPositionX: "right",
		backgroundPositionY: "bottom",
		backgroundImage: ({ iconName }) => `url(${icons[iconName]})`
	},
	// The default icon fills its grid cell and pins the artwork bottom-right.
	// Inside a centred bar that stretches the icon across the whole row and
	// shoves the label off the left edge, so the inline variant is a fixed
	// square with the artwork centred in it.
	inlineIcon: {
		color: theme.palette.gameMode.primary,
		width: 28,
		height: 28,
		minWidth: 0,
		minHeight: 0,
		flex: "0 0 auto",
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center",
		backgroundImage: ({ iconName }) => `url(${icons[iconName]})`
	}
}));

export default cardButtonIconStyles;
